import React from 'react'
import Confirm from 'views/confirm/confirm'
import { connect } from 'react-redux'
import bindActionsToDispatch from 'helpers/bindActionsToDispatch'

import myLibraryActions from 'redux/actions/my_library_actions'
import { localize } from 'helpers/translator'

const MyLibraryNoLessonsLti = props => (
	<Confirm
		btTwo={localize('global_ok')}
		alertMessage={localize('my_library_no_lessons_lti_confirm')}
		actionTwo={props.actions.closeNoLessonsLti}
		closeAction={props.actions.closeNoLessonsLti}
	/>
)

function mapDispatchToProps(dispatch) {
	return bindActionsToDispatch({
		closeNoLessonsLti: myLibraryActions.closeNoLessonsLti,
	}, dispatch)
}

export default connect(null, mapDispatchToProps)(MyLibraryNoLessonsLti)
